import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import componentObj from './dataset'

// @TODO: Add support notification(blue dots)
const Navigation = ({ selected, onClick }) => (
  <ul className="flex border-b text-primary-lightgray font-semibold">
    {componentObj.map(({ title, value, iconSeparator }, key) => (
      <Fragment key={key}>
        <li
          className={`p-5 cursor-pointer ${selected === value && 'text-primary-orange border-b border-primary-orange'}`}
          key={key}
          onClick={() => onClick(value)}
        >
          {title}
        </li>
        {iconSeparator && <li className="flex items-center px-2">
          <i className={`${iconSeparator} text-4xl text-secondary-graywhite`} aria-hidden="true"></i>
        </li>}
      </Fragment>
    ))}
  </ul>
)

Navigation.propTypes = {
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.string.isRequired,
}

export default Navigation
